module.exports = __webpack_public_path__ + "static/media/weight.82b53ad6.mp3";